const shopPageES = {
	rating: {
		reviews: "{{count}} reseñas",
	},
	searchServices: "Buscar servicios",
	main: {
		services: "Servicios",
		book: "Reservar",
		noServices: "No hay servicios disponibles.",
		reviews: "Reseñas",
		noReviews: "Aún no hay reseñas",
		attributes: "Atributos",
		noAttributes: "Aún no hay atributos",
		info: "Información",
		about: "Acerca del negocio",
		searchServices: "Buscar un servicio"
	},
	sidebar: {
		description: "Descripción",
		location: "Ubicación",
		information: "Información",
		staff: "Personal",
		contactAndHours: "Contacto y Horarios",
		noPhone: "Teléfono no disponible",
		call: "Llamar",
		getDirections: "Cómo llegar",
		hours: {
			closed: "Cerrado",
		},
		socialTitle: "Redes Sociales",
	},
};

export default shopPageES;
